import type {RouteRecordRaw} from 'vue-router';
import type {CommonRouteMeta} from '@/types/common';

const BaseDashboard = () => import('@/views/dashboard/BaseDashboard.vue');

const notifications: RouteRecordRaw[] = [
    {
        path: '/notifications',
        component: BaseDashboard,
        meta: {
            title: 'notifications',
            icon: 'mdi-newspaper-variant-multiple-outline',
            noCache: false,
            middleware: ['auth'],
            layout: 'Dashboard',
        } as CommonRouteMeta,
        children: [
            {
                path: '',
                components: {
                    default: () => import('@/views/dashboard/notifications/BaseNotifications.vue'),
                },
                name: 'notifications.index',
                meta: {
                    title: 'Notifications', icon: 'mdi-account-outline',
                    noCache: false,
                    helpArticle: 'http://help.fleetwire.io/en/article/manage-notification-preferences-in-fleetwire-732f5k/?bust=1772226818673'
                },
            },
        ],
    }
];

export default notifications;
